import React, { useState, useEffect } from 'react';
import { useFetch, Page } from "@engenharia/react-tools";
import Card from '../components/Card';

const Home = () => {
  const loggerUserData = JSON.parse(localStorage.getItem('@director/usr'));
  const { get } = useFetch();
  const [applications, setApplications] = useState([]);
  const aclFornecedorAgent = {
    "routes": {
      "route": [
        {
          "to": "/",
          "name": "Home",
          "icon": "home"
        },
        {
          "name": "Agendamento",
          "icon": "calendar-check",
          "children": {
            "route": [
              {
                "to": "/agendamento/realizar-agendamento",
                "name": "Realizar agendamento",
                "icon": "calendar-check"
              },
              {
                "to": "/agendamento/gerenciar-agendamento",
                "name": "Gerenciar agendamento",
                "icon": "calendar-check"
              }
            ]
          }
        },
        {
          "name": "Relatórios",
          "icon": "spreadsheet",
          "children": {
            "route": [
              {
                "to": "/relatorios/consultar-agendamento",
                "name": "Consultar agendamento",
                "icon": "list-filter"
              }
            ]
          }
        }
      ]
    }
  };
  const toBinary = (string) => {
    const codeUnits = new Uint16Array(string.length);
    for (let i = 0; i < codeUnits.length; i++) {
      codeUnits[i] = string.charCodeAt(i);
    }
    const charCodes = new Uint8Array(codeUnits.buffer);
    let result = '';
    for (let i = 0; i < charCodes.byteLength; i++) {
      result += String.fromCharCode(charCodes[i]);
    }
    return result;
  };

  const navigateTo = app => {
    if (!app) return;
    let jwtToken = localStorage.getItem('@director/tkn');
    let token = '';
    let domain = sessionStorage.getItem('@director/domain');
    if (app.id === 1) {
      // TODO refatorar envio de token para trabalhar com objeto ao invés de strings concatenadas
      token += `${domain}||${JSON.stringify(aclFornecedorAgent)}`;
      token = toBinary(token);
      token = btoa(token);
    }
    const url = `${app.caminho}/#/auth?tkn=${token}&jwt=${jwtToken}`;
    window.open(url, "_blank");
  };

  const getHomeApp = () =>{
    get(
      '/aplicacoes',
      (res) => {
        res.sucesso && setApplications(res.dados);
      },
      (err) => { console.log(err) }
    );
  }

  useEffect(() => {
    if (!loggerUserData) {
      window.location.href = '/#/login';
    }else{
      getHomeApp();
    }
  }, []);

  return (
    <Page title="Aplicações">
      <div className="row">
        {applications && applications.map((app, i) =>
          <Card
            key={i}
            title={app.titulo}
            description={app.descricao}
            icon={app.icone || "cil-file"}
            onClick={() => navigateTo(app)}
          />)}
      </div>
    </Page>
  );
};

export default Home;